//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.AlignmentMethodBuilder.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOptions.js";
import "../no/SectionList.js";
import "../GeometricUtilities/GeometricUtilities.Rebuild.js";
import "../GeometricUtilities/GeometricUtilities.OrientationMethodBuilder.js";
import "../GeometricUtilities/GeometricUtilities.ScalingMethodBuilder.js";
import "../no/Section.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"AlignmentMethod",0,"GeometricUtilities.AlignmentMethodBuilder",1],[1,"BodyPreference",0,"GeometricUtilities.FeatureOptions",1],[0,"G0Tolerance",1,1],[0,"G1Tolerance",1,1],[1,"GuideList",0,"SectionList",1],[1,"GuideRebuildData",0,"GeometricUtilities.Rebuild",1],[0,"InterpolationOption",1,1],[1,"OrientationMethod",0,"GeometricUtilities.OrientationMethodBuilder",1],[0,"PreserveGuideShapeOption",1,1],[0,"PreserveShapeOption",1,1],[1,"ScalingMethod",0,"GeometricUtilities.ScalingMethodBuilder",1],[1,"SectionList",0,"SectionList",1],[0,"SectionLocation",1,1],[1,"SectionRebuildData",0,"GeometricUtilities.Rebuild",1],[1,"Spine",0,"Section",1]],[],[]];
SPLM.Features.SweptBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SweptBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SweptBuilder.SectionLocationTypes = Object.freeze({
    "AnywhereAlongGuides" : "AnywhereAlongGuides", "EndsOfGuides" : "EndsOfGuides"});

SPLM.Features.SweptBuilder.InterpolationOptions = Object.freeze({
    "Linear" : "Linear", "Cubic" : "Cubic", "Blend" : "Blend"});

export default SPLM;